import React from 'react';
import Shapes from 'Shapes';
import OtoAlertNew from 'Comps/common/OtoAlertNew';
import AlertIcon from 'Icons/Alert';
var RestaurantInDebugModeAlert = function (props) {
    if (props.restaurant.status !== 'live') {
        return (React.createElement(OtoAlertNew, { color: "danger", className: "mb-2", closable: false, icon: React.createElement(AlertIcon, null) }, "Restauracja jest w trybie testowym. Mo\u017Cesz rozejrze\u0107 si\u0119, podejrze\u0107 menu, sprawdzi\u0107, czy wszystko dzia\u0142a, ale z\u0142o\u017Cone zam\u00F3wienia nie b\u0119d\u0105 realizowane."));
    }
    return null;
};
RestaurantInDebugModeAlert.propTypes = {
    // @ts-ignore todo unify shapes & intefaces
    restaurant: Shapes.restaurantShape.isRequired,
};
export default RestaurantInDebugModeAlert;
